import Axios from "axios";
import configs from "config";
import { IUser } from "types/user";

export const TOKEN_KEY = "therapist_token";
export const USER_KEY = "therapist";

export const setToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

const getToken = () => localStorage.getItem(TOKEN_KEY);

const removeToken = () => localStorage.removeItem(TOKEN_KEY);

export const hasToken = () => !!localStorage.getItem(TOKEN_KEY);

export const setUser = (user: IUser) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getUser = () => JSON.parse(localStorage.getItem(USER_KEY));

const removeUser = () => localStorage.removeItem(USER_KEY);

const axiosInstance = Axios.create({
  timeout: 3 * 60 * 1000,
  baseURL: configs.API_URL + "/therapist",
});

axiosInstance.interceptors.request.use(
  (config) => {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${getToken()}`;
    return config;
  },
  (error) => Promise.reject(error),
);

export const logout = () => {
  removeToken();
  removeUser();
  if (window.location.pathname !== configs.PUBLIC_URL + "/login") {
    window.location.href = configs.PUBLIC_URL + "/login";
  }
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response.status === 401) {
      if (hasToken()) {
        logout();
      }
    }
    return Promise.reject(error);
  },
);

export const sendGet = <T>(url: string, params?: T) =>
  axiosInstance.get(url, { params }).then((res) => res.data);
export const sendPost = <T>(url: string, params: T, queryParams?: T) =>
  axiosInstance
    .post(url, params, { params: queryParams })
    .then((res) => res.data);
export const sendPut = <T>(url: string, params: T) =>
  axiosInstance.put(url, params).then((res) => res.data);
export const sendPatch = <T>(url: string, params: T) =>
  axiosInstance.patch(url, params).then((res) => res.data);
export const sendDelete = <T>(url: string, params: T) =>
  axiosInstance.delete(url, { params }).then((res) => res.data);
